// extracted by mini-css-extract-plugin
export default {"reviewReply":"_a0jgai"};